import { inject } from "vue";

export type NavStackContextType = {
  pushSheet: (onBack: () => void) => string;
  popSheet: (id: string) => void;
  popTop: () => boolean;
};

export const NavStackContextKey = Symbol("NavStackContext");

export function useNavStack(): NavStackContextType | null {
  const context = inject<NavStackContextType>(NavStackContextKey);
  return context ?? null;
}
